export enum ContextActionWindowSizeEnum {
    Default = 0,
    Large = 1
}
